export default "__VITE_ASSET__DMHXitHN__"